import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
.popup-title{
    width: 100%; 
    text-align: center; 
    margin-bottom: 3rem;

    h1{
        font-weight: 600;
        font-size: 3rem;
        color: var(--primary);
    }
}

.add-ingredient-container{
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-bottom: 3rem;
    width: 100%;
}

.input{
    height: 6rem;
    background-color: var(--light-gray);
    border-radius: 8px;
    outline-style: none;
    border: none;
    padding: 2rem;
    font-size: 1.8rem;
    width: 100%;
}

.add-button {
    width: 100%;
}

.text-editor {
    .ql-editor {
        min-height: 15rem;
        font-size: 1.6rem;
        line-height: 1.5;
    }
    
    .ql-toolbar {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-radius: 8px 8px 0 0;
    }
    
    .ql-container {
        border-bottom: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-radius: 0 0 8px 8px;
    }
}

.close-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 10;

    img {
        width: 2rem;
        height: 2rem;
    }
}
`;

export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 4rem;
  background: white;
  overflow: auto;
  outline: none;
  width: 70rem;
  max-width: 95vw;
  min-height: 40rem;

  @media (max-width: 768px) {
    width: 90%;
    padding: 3rem;
    min-height: 35rem;
  }

  @media (max-width: 425px) {
    width: 95%;
    padding: 2rem;
    min-height: 30rem;
  }
`;
